import React from 'react';
import './Course.less';
import { Database } from '../../firebaseInit.js';
import { Link } from 'react-router';
import { Row, Item } from 'react-plan';
import { observer } from 'mobx-react';
import ProgressBar from '../../app/ProgressBar/ProgressBar.jsx';
import Button from '../../../common/js/app/Button/Button.jsx';

type Props = {
  course: Object,
  progress: ?Object
}

@observer
class Course extends React.Component {

  description: 'Displays a course excerpt + status of enrollment.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */

  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}

  render() {
    const progress = this.props.progress;
    const progressBar = (progress && progress.percentage) ?<ProgressBar percentage={ progress.percentage } /> : null;
    const cardContent = (this.props.course.status === 200) ?
      <Link className="no-underline" to={ `course/${this.props.id}`}>
        <img src={ this.props.course.thumbnail } alt={ this.props.course.name } />
        { progressBar }
        <h4>{ this.props.course.name }</h4>
        <p>{ this.props.course.description }</p>
      </Link>
    : null ;
    return (
      <Row className="course p" size="50%" medium="50%" small="100%">
        <Item className="card">
          { cardContent }
        </Item>

      </Row>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default Course;

//Unit test entry point
export const CourseTest = Course;


/** WEBPACK FOOTER **
 ** ./src/js/course/Course/Course.jsx
 **/